import { Outlet, useLocation } from "react-router-dom";
import Footer from "./components/Footer/Footer";
import Nav from "./components/Header/Header";

import { useEffect } from "react";

function Layout() {
  const { pathname } = useLocation();

  const scrollTop = () => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE
  };

  useEffect(() => {
    scrollTop();
    setTimeout(() => {
      scrollTop();
    }, 1);
  }, [pathname]);

  return (
    <>
      <Nav />
      <main
        style={{
          minHeight: "70vh",
        }}
      >
        <Outlet />
      </main>

      <Footer />
    </>
  );
}
export default Layout;
